/**
 * @module state/authStore
 * @summary Reactive auth/session state for the React UI.
 */
import { create } from 'zustand';
import type { Session } from '../types';
import { getCurrentUser, clearSession } from '../lib/auth';
import { flushAutoSave } from '../engine/persistence';

interface AuthState {
  user: Session | null;
  setUser: (u: Session | null) => void;
  logout: () => void;
}

export const useAuthStore = create<AuthState>((set) => ({
  user: getCurrentUser(),
  setUser: (u) => set({ user: u }),
  logout: () => {
    // Land any debounced autosave under this account while the session still
    // identifies it, then drop the session.
    flushAutoSave();
    clearSession();
    set({ user: null });
  },
}));
